import React, { Component } from 'react';
import Cookies from "universal-cookie";
import {connect} from 'react-redux';
import Ipcalc from './ipcalc'
import Addressplan from './addressplan'

 import './departmentNetsList.css'

import {Host} from '../../../config/config'

class Department extends Component {

  constructor(props){
    super(props)
    this.fetcher = this.fetcher.bind(this)
    this.closenetwin = this.closenetwin.bind(this)
    this.state  = {
      isFetching:true,
      accessdeny:'',
      customer:'',
      cookies :  new Cookies(),
      ipcalcdraw:false,
      addressplandraw:false,
      ipacessdraw:false,
      section:'',
      action_net:''
    }
  }


fetcher(customer){
  // fetch('http://'+Host+'/api/datauser/',
  fetch('http://'+Host+'/api/ocnitcustomerinfo/',

        {
      method: 'POST',
      headers: new Headers({
               'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type

      }),

      // body: "author="+this.state.cookies.get('sidd')+"&mode=get_nets_list&customer="+customer // <-- Post parameters
      body: "author="+this.state.cookies.get('sidd')+"&section=net&com=get_nets_list&customer="+customer // <-- Post parameters

        }    )
        .then((response)=>response.json())

          .then((nets)=>{
                          if(nets[0]['text']){this.setState({accessdeny:"Доступ запрещен"})}
                          this.setState({cnet:nets})
                        })


}

componentDidMount(){

  this.fetcher(this.props.customer)

}

componentWillReceiveProps(nextProps) {
  if(nextProps.customer !== this.props.customer) {
    this.fetcher(nextProps.customer)
  }
}

closenetwin(){
  this.setState({section:'', action_net:''})
}

  render() {
    const {cnet, section} = this.state
    return (
      <div className='depinfo'>

                    {cnet && !section ?
                      <div className='netinfodraw'>

                          <div className="centerbig">Настройки сети:</div>
                      {this.state.cnet.map((cnets)=>
                        <div key={cnets.id} className="list_docs">
                          <b>Сеть {cnets.net}</b>
                          <div>
                          <a href={null} className="pointer" onClick={()=>{this.setState({section:'ipcalc', action_net:cnets.net})}}>Настройки</a>&nbsp;
                          <a href={null} className="pointer" onClick={()=>{this.setState({section:'addressplan', action_net:cnets.net})}}>Адресный план</a>
                        </div>
                        </div>

                      )}
                      </div>
                      :
                      null
                    }
                    {section == 'ipcalc'?
                      <Ipcalc closenetwin={this.closenetwin} nets={this.state.action_net} />
                      :
                      null
                    }
                    {section == 'addressplan'?
                      <Addressplan closenetwin={this.closenetwin} nets={this.state.action_net} />
                      :
                      null
                    }





      </div>
    );
  }

}
export default connect(
  state => ({
    customers:state.customers_list
  })
)(Department);
